export default __webpack_public_path__ + "static/media/z060mi0b.2dc1f07d.mp3";